RivalIQ.apps.Shell.module('controllers', function (controllers, App, Backbone, Marionette, $, _, moment, s) {

    'use strict';

    const Controller = controllers.Controller = Marionette.Controller.extend({
        initialize: function () {

            const me = this;
            me.alerts = new Backbone.Collection();
        },
        start: function () {
            const me = this;
            const options = me.options = _.defaults(me.options, me.defaults);

            App.commands.setHandler('show:app', me.onShowAppCommand, me);
            App.commands.setHandler('show:error', me.showError, me);
            App.commands.setHandler('toggle:shell', me.toggleShell, me);
            App.commands.setHandler('show:notification', me.showNotification, me);
            App.commands.setHandler('show:modal', me.showModal, me);
            App.commands.setHandler('hide:modal', me.hideModal, me);
            App.commands.setHandler('hide:tooltips', me.hideTooltips, me);
            App.commands.setHandler('metadataMismatchReceived', me.showDataMismatchModal, me);
            App.commands.setHandler('csrfTokenMismatchReceived', me.showDataMismatchModal, me);
            App.commands.setHandler('loadingViewTimeout', me.onLoadingViewTimeout, me);
            App.commands.setHandler('show:backdrop', me.showBackdrop, me);
            App.commands.setHandler('hide:backdrop', me.hideBackdrop, me);
            App.commands.setHandler('adjust:backdrop', me.adjustBackdrop, me);
            App.commands.setHandler('set:title', me.onSetTitleCommand, me);
            App.commands.setHandler('set:document:title', me.onSetDocumentTitleCommand, me);
            App.commands.setHandler('set:components', me.onSetComponentsCommand, me);
            App.commands.setHandler('set:primary', me.onSetPrimaryCommand, me);
            App.commands.setHandler('set:navigation', me.onSetNavigationCommand, me);
            App.commands.setHandler('hide:navigation', me.hideSecondaryNavigation, me);
            App.commands.setHandler('set:sidebar:activeUrl', me.onSetSidebarActiveUrl, me);
            App.commands.setHandler('set:sidebar:activeId', me.onSetSidebarActivId, me);
            App.commands.setHandler('cacheLayer:load:fail', me.onCacheLayerLoadFailed, me);

            // put these on the root application
            RivalIQ.commands.setHandler('alert', me.onAlertCommand, me);
            RivalIQ.commands.setHandler('history:navigate', me.onHistoryNavigateCommand, me);

            // attach sub-commands to shorten usage down to 'alert:info'...
            _.each(App.views.Alert.type, function (value) {

                RivalIQ.commands.setHandler(`alert:${value}`, _.bind(me.onAlertCommand, me, value));
            });

            // Always handle metadata changes so app pieces like 1xux dont hit
            // issues
            me.handleMetadataChanges();

            if (me.options.ui) {
                me.showShell();
                me.startDataListening();
                me.showSidebar(options);
                me.showNavigation(options);
                me.showAlerts();
                me.handleExpiration();
                me.handleRenewal();
                me.handlePaymentOverdue();
                me.handleChurn();
                me.initGlobalListeners();
            }
        },

        defaults: {
            ui: true,
            page: {
                name: ''
            },
            components: {
                timePeriod: {
                    disabled: false
                },
                companySets: {
                    disabled: false,
                    onlyCompanyDisabled: false
                }
            }
        },

        hasUi: function () {

            const me = this;
            return (Marionette.getOption(me, 'ui') !== false);
        },
        showShell: function () {

            const me = this;

            if (!me.hasUi()) {

                $(document.body).addClass('no-ui');
            } else {

                $(document.body).removeClass('no-ui');
            }
        },
        showSidebar: function (options) {

            const opts = options || {};
            const sidebar = opts.sidebar || {};

            // TODO sidebar should be a model that constructs this itself
            sidebar.items = new Backbone.Collection(sidebar.items);

            const view = new App.views.Sidebar({
                model: new Backbone.Model(sidebar)
            });

            App.sidebar.show(view);
        },
        showPrimaryNavigation: function (options) {
            const me = this;
            const opts = _.pick(options, 'page', 'components');

            const sidebar = _.get(opts, ['components', 'sidebar']);
            if (sidebar && sidebar.id) {
                me.onSetSidebarActiveId(sidebar.id);
            } else {
                me.onSetSidebarActiveUrl();
            }

            App.sectionHeader.show(new App.views.PrimaryNavigation({
                model: new Backbone.Model(opts)
            }));
        },
        showSecondaryNavigation: function (options) {

            const me = this;
            const opts = options || {};
            const page = opts.page || {};
            const items = page.items;
            const $el = $('nav.navbar-white');

            const filteredItems = _.filter(items, function (item) {
                return _.isUndefined(item.display) || _.result(item, 'display');
            });

            const hasSecondaryNav = (!_.isEmpty(filteredItems) && me.hasUi() && !_.get(page, ['metadata', 'channelRedacted'], false)) || options.view;

            // TODO this should use a view and regions
            if (!hasSecondaryNav) {
                App.secondaryNavigation = null;
                $el.hide();
                $('#content').removeClass('secondary-nav');
                return;
            }

            $('#content').addClass('secondary-nav');

            if (options.view) {
                $el.show();
                return App.secondaryNav.show(options.view);
            }

            const collection = new Backbone.Collection(items);
            let activeModel = collection.first();

            const navigationTitle = function (item) {
                let itemName = item.get('name');
                if (_.isFunction(itemName)) {
                    itemName = itemName();
                }
                return $.trim([(page.name ? `${page.name} -` : ''), itemName].join(' '));
            };

            for (let item, active, navigation, i = 0, l = collection.length; i < l; i++) {

                item = collection.at(i);
                navigation = item.get('navigation');

                if (navigation) {

                    navigation.title = _.bind(navigationTitle, null, item);
                }

                active = Boolean(_.result(item.attributes, 'menuItemActive'));

                if (active) {

                    activeModel = item;
                    break;
                }
            }

            App.secondaryNavigation = new App.views.SecondaryNavigation({
                el: $el,
                collection: collection,
                landscapeStateEvents: {
                    'change:activeSources': 'render'
                },
                model: new Backbone.Model({
                    name: page.name || 'secondary',
                    activeModel: activeModel
                })
            });

            App.secondaryNavigation.render().$el.show();
        },
        showNavigation: function (options) {
            const me = this;

            if (me.options.ui) {
                me.showPrimaryNavigation(options);
                me.showSecondaryNavigation(options);
            }
        },
        hideSecondaryNavigation: function () {
            if (App.secondaryNavigation) {
                App.secondaryNavigation.$el.hide();
            }
        },
        showAlerts: function () {

            const me = this;

            new App.views.Alerts({
                el: '.alert-container',
                collection: me.alerts
            }).render();
        },
        showContent: function (view) {

            App.content.show(view);
        },
        showLoading: function () {

            App.content.showLoading();
        },
        showError: function (error) {

            const me = this;

            const view = new App.views.Error({
                model: new Backbone.Model({
                    error: error
                })
            });

            RivalIQ.logger.error(`shell error received: ${JSON.stringify(error)}`);

            me.showContent(view);
        },

        toggleShell: function (show) {
            $('body').toggleClass('hide-shell', !show);
        },

        startDataUpdatePoller: function () {
            if (!RivalIQ.state.user.isActive()) {
                return;
            }

            RivalIQ.state.landscape.pollForNewCompanyData();
            RivalIQ.state.versioning.poll();
        },

        startDataListening: function () {
            const me = this;
            me.startDataUpdatePoller();
        },

        handleMetadataChanges: function () {
            $(window).ajaxSuccess(RivalIQ.state.versioning.globalXhrLandscapeHandler);
        },

        handleChurn: function () {

            const me = this;

            function showChurnNotification() {
                if (me.hasUi()) {
                    // Only display if the shell is visible
                    me.showNotification(App.enums.notifications.CANCELED, {
                        size: App.enums.navigation_size.DEFAULT
                    });
                }
            }

            if (RivalIQ.state.account.churned()) {
                showChurnNotification();
            }

            me.listenTo(RivalIQ.state.account, 'change:selfChurned', function (model, churned) {
                if (churned) {
                    showChurnNotification();
                } else {
                    me.hideNotification();
                }
            });
        },

        handleRenewal: function () {
            const me = this;
            const state = RivalIQ.state.account;

            if (state.contractRequiresRenewal()) {
                const daysToRenewal = state.getDaysUntilContractRenewal();
                if (_.isFinite(daysToRenewal) && daysToRenewal <= 30) {
                    me.showNotification(App.enums.notifications.RENEWAL_CENTER, {
                        size: App.enums.navigation_size.SHORT
                    });
                }
            }
        },

        handlePaymentOverdue: function () {
            const me = this;
            if (RivalIQ.state.account.showPaymentOverdueWarning()) {
                me.showNotification(App.enums.notifications.PAYMENT_OVERDUE, {
                    size: App.enums.navigation_size.SHORT
                });
            }
        },

        handleExpiration: function () {

            const me = this;
            const account = RivalIQ.state.account;

            if (account.trialExpired()) {

                const companies = RivalIQ.state.landscape.get('companies');
                const hasNoCompanies = (!companies || companies.length === 0);

                // NOTE if the expired user has an empty landscape then we need
                // to just go immediately to the obscured pay wall, as there is
                // nothing they can do in the app anyway at this point
                if (!RivalIQ.state.product.onAccessiblePage() &&
                    (hasNoCompanies || (!account.getExpiredVisitsRemaining() && !account.isImpersonated()))) {

                    return me.showModal(new App.views.PaywallModal({
                    }));
                }

                me.interceptLinks(function () {
                    const view = new App.views.PaywallModal({
                        backdrop: true,
                        blur: false
                    });
                    me.showModal(view);
                }, [
                    /^\/companies$/,
                    /^\/account/,
                    /^\/manage/
                ]);

                return me.showNotification(App.enums.notifications.TRIAL_EXPIRED);
            }

            if (account.isTrialing() && !account.inRegistration()) {
                const trialExpiresSoon = account.getDaysRemainingInTrial() < RivalIQ.state.product.get('trialExpiresSoonDaysLeft');
                const isOnTrialPlan = RivalIQ.state.plan.id === RivalIQ.state.product.get('defaultPlanId');

                if (trialExpiresSoon && isOnTrialPlan) {
                    me.showNotification(App.enums.notifications.TRIAL_EXPIRES_SOON, {
                        size: App.enums.navigation_size.SHORT
                    });
                } else {
                    // Don't show the trial banner for the first day of the trial.
                    const activatedAt = account.get('activatedAt');
                    if (!activatedAt || moment.utc().diff(activatedAt, 'day') >= 1) {
                        me.showNotification(App.enums.notifications.TRIAL, {
                            size: App.enums.navigation_size.SHORT
                        });
                    }
                }
            }
        },

        isNotificationDismissed: function (id) {
            const state = RivalIQ.state.user;
            const persisted = _.get(state.get('notifications'), id, {});

            const dismissed = persisted.dismissed;
            let dismissedUntil = null;

            if (_.exists(dismissed)) {
                dismissedUntil = moment.utc(dismissed);
            }

            // omit if dismissed is true or a valid date in the past
            // NOTE: moment isBefore returns false for invalid dates
            return (dismissed === true ||
                (dismissedUntil && moment.utc().isBefore(dismissedUntil)));
        },

        showNotification: function (notificationType, options) {
            const me = this;
            const region = App.notificationRegion;

            // NOTE if the region element does not exist or the notification
            // has been dismissed then we cannot render
            if (region.$el.length === 0 || me.isNotificationDismissed(notificationType)) {

                return;
            }

            const attrs = _.extend({}, options, {
                model: App.data.notifications.get(notificationType)
            });

            region.show(new App.views.Notification(attrs));
        },

        hideNotification: function () {
            App.notificationRegion.reset();
        },

        interceptLinks: function (action, customExceptions) {
            const exceptions = _.compact([/mailto/].concat(customExceptions));

            const clickHandler = function (e) {

                // NOTE check exemptions based on the target of the link
                const href = $(e.currentTarget).attr('href');
                const isExempt = _.some(exceptions, function (exception) {
                    return href.match(exception);
                });

                if (isExempt) {
                    return;
                }

                e.preventDefault();
                e.stopPropagation();
                action();
            };

            const buttonHandler = function (e) {

                // NOTE check exemptions based on the current page
                const href = window.location.pathname;
                const isExempt = _.some(exceptions, function (exception) {
                    return href.match(exception);
                });

                if (isExempt) {
                    return;
                }

                e.preventDefault();
                e.stopPropagation();
                action();
            };

            _.each([
                App.sectionHeader,
                App.secondaryNav,
                App.content
            ], region => {
                region.$el.on('click', 'a[href]', clickHandler);
                region.$el.on('click', 'button', buttonHandler);
            });
        },

        showBackdrop: function (onClick) {
            const me = this;
            App.backdrop.$el.addClass('in');
            me.adjustBackdrop();
            App.backdrop.$el.on('click', onClick);
        },

        hideBackdrop: function () {
            App.backdrop.$el.removeClass('in');
            App.backdrop.$el.off('click');
        },

        adjustBackdrop: function () {
            App.backdrop.$el.height($(document).height());
        },

        _getModalRegion: function () {
            return App.modal;
        },

        showModal: function (view) {
            const me = this;
            let modal = view;
            const className = view.className || 'modal';
            const options = view.options || {};

            if (!view.render) {

                if (_.isString(view)) {

                    modal = new Marionette.ItemView({
                        className: className,
                        template: view
                    });
                } else {

                    modal = new App.views.Modal({
                        model: new Backbone.Model(view)
                    });
                }
            }

            const modalRegion = me._getModalRegion();
            if (modalRegion.$el) {
                me.hideModal();
            }

            modalRegion.show(modal, {
                forceShow: true
            });

            const show = function () {
                const $modal = modalRegion.$el.find('.modal');
                $modal.modal('show');

                $modal.on('shown.bs.modal', function () {
                    if (options.onShowModal) {
                        options.onShowModal($(this));
                    }
                    RivalIQ.trigger('modal:shown', arguments);
                });
            };

            const relayLoadingFinished = function () {
                RivalIQ.trigger('modal:loading:finished', arguments);
            };

            // NOTE when the modal view is a loading view we need to wait until
            // data has loaded before trying to "modalize" it (for lack of a
            // better word)
            if (modal.isLoadingView) {
                me.listenTo(modal, 'render:loaded', show);
                me.listenTo(modal, 'loading:finished', relayLoadingFinished);
            } else {
                show();
            }
        },

        hideModal: function () {
            App.modal.$el.find('.modal').modal('hide');
        },

        hideTooltips: function () {
            $('.tooltip.in').hide();
        },

        showDataLoadError: _.debounce(function (message) {
            RivalIQ.execute('alert:danger', message);
        }, 500),

        showDataMismatchModal: function () {
            const me = this;

            if (_.get(RivalIQ, 'curation.loading') || App.isHeadless) {
                // if the current curation is loading, just refresh the page
                window.location.reload();
            } else {
                // notify the user that they will need to refresh
                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedDataMismatchModal);
                me.showModal(new App.views.VersionErrorModal());
            }
        },

        onLoadingViewTimeout: function (context) {
            const me = this;
            if (!me.hadLoadingViewTimeout) {
                me.hadLoadingViewTimeout = true;
                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.LoadingViewTimeout, context);
            }
        },

        onAlertCommand: function (type, message, options) {
            const me = this;
            const alerts = me.alerts;
            const model = App.views.Alert.createModelByType(type, message, options);
            alerts.add(model);
        },

        onHistoryNavigateCommand: function (path, options) {
            options = options || {};


            let destination = path;
            const params = _.get(options, 'params', {});
            const queryString = $.param(params);
            if (queryString) {
                const a = document.createElement('a');
                a.href = (_.first(destination) !== '/' ? '/' : '') + destination;
                destination = [destination, queryString].join((a.search ? '&' : '?'));
            }

            Backbone.history.navigate(destination, _.omit(options, 'doNotTrack', 'params'));

            // NOTE: this bit tells the tracking code later on (after the curation has been loaded) to fire a page_view event to gtag.
            // See RivalIQ.apps.Dashboard.curation.filters.track
            RivalIQ.trackPageView = (options.trigger && !options.doNotTrack);
        },

        initGlobalListeners: function () {
            $('body').on('click', '[data-toggle="contact-us"]', function (e) {
                const $trigger = $(e.currentTarget);
                const toHide = $trigger.data('dismiss');
                if (toHide === 'popover') {
                    $trigger.parents('.popover').popover('hide');
                }

                RivalIQ.execute('show:modal', new RivalIQ.apps.Shell.views.ContactUsModal({
                    model: new Backbone.Model({
                        context: $trigger.data('context')
                    })
                }));
            });
        },

        onShowCommand: function (options, fn) {

            const me = this;
            const deferred = new $.Deferred();

            options = _.defaults(options, me.defaults);
            me.showNavigation(options);

            deferred
                .done(_.bind(me.showContent, me))
                .fail(_.bind(me.showError, me));

            me.showLoading();

            RivalIQ.utils.async.invoke(fn, deferred);
        },

        showApp: function (config) {
            const me = this;
            const app = config.app;
            const options = config.options || {};
            const $body = $('body');
            config = _.defaults(config, me.defaults);

            // NOTE clean up an existing app if there is one. for the time
            // being this just means that we stop listening to events from it
            // and delete the reference
            if (me._app) {

                me.stopListening(me._app);
                $body.removeClass(s.dasherize(s.decapitalize(me._app.name)));
                delete me._app;
            }

            me._app = app;
            $body.addClass(s.dasherize(s.decapitalize(me._app.name)));

            me.listenTo(app, 'app:error', me.showError);

            // NOTE it is expected that layout is a reference to a class
            const Layout = config.layout;
            const deferred = new $.Deferred();

            // NOTE this callback will be fired when the options have been
            // resolved - this can occur either sync or async
            const onOptionsReady = function (layout, options) {

                if (layout) {

                    app.getLayout = function () {

                        return layout;
                    };
                }

                app.start(options);
            };

            if (Layout) {

                me.onShowCommand(config, function (callback) {

                    deferred
                        .done(function (resolvedOptions) {
                            // NOTE the layout specified in the configuration is assumed
                            // to be a kind of bootstrap for the content region
                            const view = new Layout(resolvedOptions);
                            view.once('show', _.bind(onOptionsReady, null, view, resolvedOptions));
                            callback(null, view);
                        })
                        .fail(_.bind(me.showError, me));
                });

            } else {

                me.showNavigation(config);
                deferred.done(_.bind(onOptionsReady, null, null));
            }

            if (_.isFunction(options)) {

                return RivalIQ.utils.async.invoke(options, deferred);
            }

            deferred.resolve(options);
        },

        onShowAppCommand: function (config) {

            const me = this;

            if (!RivalIQ.apps.Shell.started) {
                RivalIQ.apps.Shell.once('started', function () {
                    me.showApp(config);
                });
            } else {
                me.showApp(config);
            }
        },
        onSetTitleCommand: function (title) {

            const me = this;
            me.onSetPrimaryCommand(title);
        },
        onSetComponentsCommand: function (components) {

            const me = this;
            let page = null;
            const currentView = App.sectionHeader.currentView;

            if (currentView && currentView.model) {

                page = currentView.model.get('page');
            }

            const config = {
                page: _.defaults(page || {}, me.defaults),
                components: _.defaults(components || {}, me.defaults.components)
            };

            me.showPrimaryNavigation(config);
        },
        onSetPrimaryCommand: function (title, components) {

            const me = this;

            let page = title;
            if (_.isString(title)) {
                page = {
                    name: _.escape(title)
                };

                // Set document title for pages with no secondary navigation
                me.onSetDocumentTitleCommand(title);
            } else if (title.render) {
                page = {
                    name: title
                };
            }

            const pageComponents = _.defaults(components || {}, me.defaults.components);

            pageComponents.companySets.onlyCompanyDisabled = false;

            const config = {
                page: page,
                components: pageComponents
            };

            me.showPrimaryNavigation(config);
        },
        onSetDocumentTitleCommand: function (title) {

            if (!title) {

                return;
            }

            document.title = [_.unescape(title), 'Rival IQ'].join(' | ');
        },
        onSetNavigationCommand: function (options) {

            const me = this;
            me.showSecondaryNavigation(options);

            // NOTE: expired token banner has different styles on Connected Services page
            $('body').toggleClass('account-services', (window.location.pathname === '/account/services'));
        },
        onSetSidebarActiveUrl: function (url) {
            url = url || window.location.pathname;

            const sidebar = App.sidebar.currentView;
            if (sidebar) {
                const path = RivalIQ.configuration.sidebar.getActiveSidebarPath(url);
                sidebar.activateChildByUrl(path);
            }
        },
        onSetSidebarActiveId: function (id) {
            const sidebar = App.sidebar.currentView;
            if (sidebar) {
                sidebar.activateChildById(id);
            }
        },
        onCacheLayerLoadFailed: function (error) {
            const me = this;
            let message = null;
            switch (error.errorName) {
                case 'TooMuchHistoryRequestedError':
                    message = RivalIQ.strings.too_much_history_requested;
                    break;
                case 'TooMuchDataRequestedError':
                    message = RivalIQ.strings.too_much_data_requested;
                    break;
                default:
                    message = null;
            }

            if (message) {
                me.showDataLoadError(message);
            }
        }
    });

    controllers.addInitializer(function (options) {

        const controller = new Controller(options);
        controller.start();
    });

}, window.moment, window.s);
